export default "__VITE_ASSET__IXYfUPYL__"